import { useEffect, useState } from "react";
import { set, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Badge, Button, Col, DropdownMenu, DropdownToggle, Form, Row, UncontrolledDropdown } from "reactstrap";

import { BASE_URL_IMG } from "../../assets/constants";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
  TooltipComponent,
  UserAvatar,
} from "../../components/Component";
import useLogout from "../../hooks/useLogout";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import ConfirmModal from "../../MyComp/UI/modals/ConfirmModal";
import ViewImage from "../../MyComp/UI/modals/ViewImage";

import ApiPaginationDataTable from "../../MyComp/UI/DataTable/ApiPaginationDataTable";
import { getSmartInitials } from "../../utils/Utils";
import { UserAvatarCell } from "../../MyComp/ImageView/UserAvatarCell";
import { labAPI } from "../../api/doctor";
import ServerSideDataTable from "../../MyComp/UI/DataTable/ServerSideDataTable";
import MyDataTable from "../../MyComp/UI/DataTable/MyDataTable";
import { getRoles } from "@testing-library/react";

const IndividualLab = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      server_search: "",
      page: 1,
      limit: 25,
    },
  });
  const userRole = localStorage.getItem("role")?.toLowerCase()?.trim();

  const isAdmin = userRole === "admin";
  const isLab = userRole === "lab";
  const { logout } = useLogout();
  const navigate = useNavigate();
  // Separate table state from form
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [mode, setMode] = useState("Add");
  const [imageOpen, setImageOpen] = useState(false);
  //pagination
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);

  // pagination
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setPerPage(newPerPage);
    setCurrentPage(page);
  };
  const [search, setSearch] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const columns = [
    // {
    //   name: "Name",
    //   selector: (row) => row?.name || "-",
    // },

    {
      name: "Name",
      sortable: true,
      wrap: false,
      cell: (row) => {
        const fullName = row?.name || "";

        return (
          <div
            title={fullName} // full text on hover
            style={{
              maxWidth: "150px",
              overflow: "hidden",
              cursor: "pointer",
            }}
          >
            {truncateByCharacters(fullName, 20)}
          </div>
        );
      },
    },

    {
      name: "Type",
      // width: "220px",
      cell: (row) => {
        const fullType = row?.labCategoryName || "-";

        // split categories
        const categories = fullType.split(",").map((c) => c.trim());

        return (
          <div
            title={fullType} // full text on hover
            style={{
              maxWidth: "220px",
              overflow: "hidden",
              // whiteSpace: "nowrap",
              cursor: "pointer",
            }}
          >
            {categories.map((category, index) => (
              <Badge key={index} color="outline-secondary" className="me-1">
                {truncateByCharacters(category, 15)}
              </Badge>
            ))}
          </div>
        );
      },
    },

    {
      name: "Address",
      sortable: true,
      wrap: false,
      cell: (row) => {
        const fullAddress = row?.address || "";

        return (
          <div
            title={fullAddress} // full text on hover
            style={{
              maxWidth: "150px",
              overflow: "hidden",
              cursor: "pointer",
            }}
          >
            {truncateByCharacters(fullAddress, 20)}
          </div>
        );
      },
    },

    {
      name: "Mobile Number",
      selector: (row) => row?.mobile || row?.mobile || "-",
      sortable: true,
      wrap: true,
      // width: "140px",
    },
    {
      name: "District",
      selector: (row) => row?.district || row?.district || "-",
      sortable: true,
      wrap: true,
      width: "100px",
    },
    {
      name: "KYC",
      selector: (row) => row?.kyc_status,
      cell: (row) => (
        <div
          style={{ cursor: "pointer" }}
        //  onClick={() => handleToggleStatus(row)}
        >
          <Badge
            className="text-capitalize"
            color={`${row.kyc_status == "pending"
              ? "outline-warning"
              : row?.kyc_status == "Approved"
                ? "outline-primary"
                : row?.kyc_status == "In Review"
                  ? "outline-info"
                  : "outline-danger"
              }`}
          >
            {row?.isSelected && <Icon color={"success"} name={row?.isSelected ? "star" : ""} />}
            {row.kyc_status}
          </Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
      width: "80px",
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div
          style={{ cursor: "pointer" }}
        // onClick={() => handleToggleStatus(row)}
        >
          <Badge color={row.status ? "success" : "danger"}>{row.status ? "Active" : "InActive"}</Badge>
        </div>
      ),
      sortable: true,
      width: "100px",
    },
    {
      name: "Action",
      cell: (row) => {


        const userRole = localStorage.getItem("role")?.toLowerCase()?.trim();
        const isLab = userRole === "lab";
        const isAdmin = userRole === "admin";

        const status = row?.kyc_status?.toLowerCase()?.trim();
        const isReview = status === "in review";
        const isApproved = status === "approved";

        // 🔴 REVIEW CASE
        if (isReview) {
          return (
            <>
              {/* ✅ LAB → ONLY EDIT */}
              {isLab && (
                <>
                  <Button
                    id={`edit-${row?.id}`}
                    outline
                    color="warning"
                    size="xs"
                    onClick={() => handleEdit(row)}
                  >
                    <Icon name="edit" />
                  </Button>

                  <TooltipComponent
                    iconClass="card-hint"
                    direction="top"
                    id={`edit-${row?.id}`}
                    text="Edit Lab"
                  />
                </>
              )}

              {/* ✅ ADMIN → ALL BUTTONS EXCEPT EDIT */}
              {isAdmin && (
                <>
                  {/* 👁 VIEW */}
                  <Button
                    id={`app-${row?.id}`}
                    outline
                    color="success"
                    size="xs"
                    onClick={() => handleShowDetails(row)}
                  >
                    <Icon name="eye" />
                  </Button>

                  <TooltipComponent
                    iconClass="card-hint"
                    direction="top"
                    id={`app-${row?.id}`}
                    text="View and Approval Laboratory"
                  />

                  {/* 🏥 VIEW TEST */}
                  <Button
                    id={`view-${row?.id}`}
                    className="mx-1"
                    outline
                    color="warning"
                    size="xs"
                    onClick={() => handleViewTest(row)}
                  >
                    <Icon name="building" />
                  </Button>

                  <TooltipComponent
                    iconClass="card-hint"
                    direction="top"
                    id={`view-${row?.id}`}
                    text="View Test"
                  />
                </>
              )}
            </>
          );
        }

        // 🟢 OTHER STATUS (NOT REVIEW)
        return (
          <>
            {/* 👁 VIEW */}
            <Button
              id={`app-${row?.id}`}
              outline
              color="success"
              size="xs"
              onClick={() => handleShowDetails(row)}
            >
              <Icon name="eye" />
            </Button>

            <TooltipComponent
              iconClass="card-hint"
              direction="top"
              id={`app-${row?.id}`}
              text="View and Approval Laboratory"
            />

            {/* 🏥 VIEW TEST */}
            <Button
              id={`view-${row?.id}`}
              className="mx-1"
              outline
              color="warning"
              size="xs"
              onClick={() => handleViewTest(row)}
            >
              <Icon name="building" />
            </Button>

            <TooltipComponent
              iconClass="card-hint"
              direction="top"
              id={`view-${row?.id}`}
              text="View Test"
            />

            {/* ✏️ EDIT (LAB ONLY, NOT APPROVED) */}
            {isLab && !isApproved && (
              <>
                <Button
                  id={`edit-${row?.id}`}
                  outline
                  color="warning"
                  size="xs"
                  onClick={() => handleEdit(row)}
                >
                  <Icon name="edit" />
                </Button>

                <TooltipComponent
                  iconClass="card-hint"
                  direction="top"
                  id={`edit-${row?.id}`}
                  text="Edit Lab"
                />
              </>
            )}

            {/* 📊 DASHBOARD */}
            {isApproved && (
              <>
                <Button
                  id={`dash-${row?.id}`}
                  outline
                  color="primary"
                  size="xs"
                  className="mt-1"
                  onClick={() => handleGoDashboard(row)}
                  style={{ marginLeft: "6px", marginBottom: "6px" }}
                >
                  <Icon name="presentation" />
                </Button>

                <TooltipComponent
                  iconClass="card-hint"
                  direction="top"
                  id={`dash-${row?.id}`}
                  text="View Dashboard"
                />
              </>
            )}
          </>
        );
      },
    }
  ];

  const handleViewTest = (row) => {
    navigate("/test", { state: { labId: row?.id, name: row?.name } })
  };
  const handleGoDashboard = (row) => {
    console.log(row, "row")
    navigate("/laboratory-dashboard", { state: { labId: row?.id, name: row?.name } });
  };

  useEffect(() => {
    fetchLabs();
  }, [currentPage, perPage, search]);

  const fetchLabs = async () => {
    setLoading(true);

    const body = {
      search,
      page: currentPage,
      limit: perPage,
    };

    try {
      const res = await labAPI(body);

      if (res?.data?.status === true) {
        const apiData = res?.data?.data || {};

        const rows = Array.isArray(apiData)
          ? apiData
          : Array.isArray(apiData)
            ? apiData
            : Array.isArray(apiData)
              ? apiData
              : [];

        const total = apiData.totalRecords || apiData.total || 0;
        console.log(rows);

        setTableData(rows);
        setTotalRows(total);
      } else {
        setTableData([]);
        setTotalRows(0);
      }
    } catch (error) {
      console.error("Lab API Error:", error);
      toast.error("Failed to load lab list");
      setTableData([]);
      setTotalRows(0);
    } finally {
      setLoading(false);
    }
  };
  const handleShowDetails = (row) => {
    console.log("rowEdit", row);
    navigate(`/laboratory-details?labId=${row?.id}`, { state: { labId: row?.id, mode: "Approval" } });
  };
  const handleEdit = (row) => {
    console.log("rowEdit", row);
    navigate(`/lab-form?labId=${row?.id}`, { state: { labId: row?.id, mode: "Approval" } });
  };

  const truncateByCharacters = (text = "", charLimit = 20) => {
    if (!text) return "";

    return text.length > charLimit ? text.slice(0, charLimit) + "..." : text;
  };

  return (
    <>
      <Head title="Lab" />
      <Content>
        <BlockHead size="sm" className="mb-0 pb-0">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Laboratory
              </BlockTitle>
            </BlockHeadContent>
            {/* <BlockHeadContent>
              <Button
                color="primary"
                outline
                className="me-n1"
                onClick={() => {
                  navigate("/laboratory-and-diagnostics/lab-and-diagnostic-profile", { state: { mode: "Add" } });
                }}
              >
                <Icon name={isOpen ? "minus" : "plus"} />
              </Button>
            </BlockHeadContent> */}
          </BlockBetween>
        </BlockHead>

        <Block className="pt-0">
          {/* <Row className="mb-3">
            <Col md="4">
              <input
                type="text"
                className="form-control"
                placeholder="Search lab..."
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  setCurrentPage(1);
                  setResetPaginationToggle((prev) => !prev);
                }}
              />
            </Col>
          </Row> */}

          <MyDataTable data={tableData} columns={columns} title="Laboratory List" isLoading={loading} />
          {/* <ServerSideDataTable
            columns={columns}
            data={tableData}
            title="Lab List"
            isLoading={loading}
            totalRows={totalRows}
            perPage={perPage}
            currentPage={currentPage}
            handlePageChange={handlePageChange}
            handlePerRowsChange={handlePerRowsChange}
            resetPaginationToggle={resetPaginationToggle}
          /> */}
        </Block>
      </Content>
    </>
  );
};

export default IndividualLab;
